export type CategoryId = number|string

export type CategoryTreeItem = {
	categorySerial: CategoryId
	parentSerial?: CategoryId
	title: string
	children?: CategoryTreeItem[]
	isLinked: boolean
}

export type FlatCategoryTreeItem = CategoryTreeItem & {
	depth: number
}

export type CategoryTreeItemCallJs = {
	categorySerial: string|number
	parentSerial?: string|number
	title: string
	children?: CategoryTreeItemCallJs[]
	isLinked: boolean
}

export const categoryFromCallJsCategory = (cat: CategoryTreeItemCallJs): CategoryTreeItem => ({
	categorySerial: +cat.categorySerial,
	parentSerial: 'parentSerial' in cat && cat.parentSerial !== undefined ? +cat.parentSerial : undefined,
	title: cat.title,
	children: 'children' in cat && cat.children !== undefined ? cat.children.map(categoryFromCallJsCategory) : undefined,
	isLinked: cat.isLinked
})



// WEBPACK FOOTER //
// ./src/lib/category-manager/data.ts